import Vue from 'vue';
import VueRouter from 'vue-router';
// import store from '@/store';

// Guards
import LoggedOutGuard from '@/services/RouteGuards/LoggedOut';
import SuperOrAgent from '@/services/RouteGuards/SuperOrAgent';
import SuperOrAdmin from '@/services/RouteGuards/SuperOrAdmin';

// Views
import KitchenSink from '@/views/KitchenSink.vue';
import Error from '@/views/Error.vue';
import Auth from '@/views/Auth';
import Admin from '@/views/Admin';
import Main from '@/views/Main';
import LandingPage from '@/views/LandingPage.vue';

// Routes
import auth from '@/router/auth';
import stages from '@/router/admin/stages';
import adminProperties from '@/router/admin/properties';
import agents from '@/router/admin/agents';
import admins from '@/router/admin/admins';
import customers from '@/router/admin/customers';
import settings from '@/router/admin/settings';
import mainProperties from '@/router/main/properties';
import mainCustomers from '@/router/main/customers';
import mainSettings from '@/router/main/settings';

Vue.use(VueRouter);

const routes = [
	{
		path: '/kitchen-sink',
		name: 'Kitchen Sink',
		component: KitchenSink,
		meta: {
			title: `Kitchen Sink - ${process.env.VUE_APP_NAME}`
		}
	},
	{
		path: '/auth',
		name: 'Auth',
		component: Auth,
		children: auth,
		beforeEnter: LoggedOutGuard
	},
	{
		path: '/admin',
		name: 'Admin',
		component: Admin,
		children: [
			...stages,
			...adminProperties,
			...agents,
			...admins,
			...customers,
			...settings
		],
		beforeEnter: SuperOrAdmin
	},
	{
		path: '/',
		name: 'Main',
		component: Main,
		children: [
			...mainProperties,
			...mainCustomers,
			...mainSettings
		],
		beforeEnter: SuperOrAgent
	},
	{
		path: '*',
		name: '404',
		component: Error,
		meta: {
			title: `404 - ${process.env.VUE_APP_NAME}`
		}
	},
	{
		path: '/landing',
		name: 'LandingPage',
		component: LandingPage,
		meta: {
			title: `Landing Page - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperOrAgent
	}
];

const router = new VueRouter({
	mode: 'history',
	linkExactActiveClass: 'is-active',
	base: process.env.BASE_URL,
	routes
});

// Set page title after each route change
router.afterEach((to, from) => {
	Vue.nextTick(() => {
		document.title = to.meta.title || process.env.VUE_APP_NAME;
		// Prevent scroll blocking on any change due to a lot of popups
		document.querySelector('body').classList.remove('prevent-scroll');
	});
});

// This is commented because of to many requests for user
// router.beforeEach(async (to, from, next) => {
// 	// If user is logged in, refresh local user data after each route change
// 	if (store.getters.getLoggedIn) {
// 		store.dispatch('fetchUser');
// 	}
//
// 	next();
// });

export default router;
